import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { JsMethodLoadingContext } from './jsMethodLoadingContext';

export const JsMethodLoadingProvider = ({ children }: { children: ReactNode }) => {
  const [loadingKeys, setLoadingKeys] = useState<Set<string>>(() => new Set());

  const setLoading = useCallback((key: string, loading: boolean) => {
    setLoadingKeys((current) => {
      const isCurrentlyLoading = current.has(key);
      if (isCurrentlyLoading === loading) {
        return current;
      }

      const next = new Set(current);
      if (loading) {
        next.add(key);
      } else {
        next.delete(key);
      }
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ isAnyLoading: loadingKeys.size > 0, setLoading }),
    [loadingKeys, setLoading]
  );

  return (
    <JsMethodLoadingContext.Provider value={value}>{children}</JsMethodLoadingContext.Provider>
  );
};
